/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="82.5"
        height="82.55"
        viewBox="0 0 82.5 82.55"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M20.21 20.26a1.25 1.25 0 0 1 1.73-.36l.45.31.93.64.68.49 1.52 1.09.41.3q1.57 1.16 3.27 2.46l1.37 1.06c1.85 1.45 3.79 3 5.8 4.68A263.41 263.41 0 0 1 68 62.16q7.6 8.91 14.24 18.42a1.254 1.254 0 0 1-2.06 1.43A228.8 228.8 0 0 0 66.1 63.79a259.81 259.81 0 0 0-31.32-30.93l-.78-.62L32.56 31l-.72-.59-1.42-1.13c-1.17-.93-2.31-1.82-3.41-2.65l-1.3-1-.63-.47-1.42-1-.75-.54-1-.73-1.07-.74-.28-.15a1.24 1.24 0 0 1-.35-1.74Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M35.63 31.2a1.25 1.25 0 0 1 .37 2.47h-.13l-20 2a1.25 1.25 0 0 1-.37-2.47h.13ZM50.46 44.23a1.25 1.25 0 0 1 .7 2.4h-.12l-25 6a1.25 1.25 0 0 1-.7-2.39h.12Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M39.5 16.11a1.25 1.25 0 0 1 2.42.61v.13l-5 16a1.24 1.24 0 0 1-1.56.82 1.26 1.26 0 0 1-.86-1.44v-.12ZM52.52 29.22a1.25 1.25 0 0 1 2.48.33v.13l-3 16a1.252 1.252 0 0 1-2.48-.34v-.12Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#0e497b"
          d="M2.18 0h-1A1.27 1.27 0 0 0 0 1.23v5.42a163.64 163.64 0 0 0 2.43 23.28C5.27 45.81 10.26 58.49 18 66.22a34.04 34.04 0 1 0 48.14-48.14c-6.43-6.44-16.36-11-28.82-14A150.83 150.83 0 0 0 13.71.5C10.77.28 7.99.14 5.43.06L4 0H3Zm.33 3.54v-1h2.94c2.52.07 5.26.21 8.16.43a147.73 147.73 0 0 1 23.2 3.53c12.06 2.91 21.59 7.29 27.65 13.35a31.544 31.544 0 0 1-44.61 44.61c-7.3-7.3-12.12-19.55-14.88-35A161.88 161.88 0 0 1 2.51 3.54Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'LeafIcon';

export default Icon;
